/**
 * Eén bron van waarheid voor het publieke adres van de site. Gebruikt door de canonicals,
 * og:url en JSON-LD (Seo.tsx) én — via config/site.json — door generate-sitemap.mjs en
 * prerender.mjs. Bij livegang hoef je alleen `origin` in config/site.json om te zetten.
 */
import site from "../../config/site.json";

/** Publiek adres zonder slash aan het eind, bv. "https://glastotaal.nl". */
export const SITE_URL: string = String(site.origin).replace(/\/+$/, "");

/**
 * Alleen het echte domein mag in Google. Draait de build op een ander adres (de
 * web.app-testomgeving, een preview-channel), dan zet elke pagina zichzelf op noindex —
 * anders concurreert de testomgeving met je eigen site. Zo is er geen aparte schakelaar
 * die je bij livegang kunt vergeten: het volgt automatisch uit `origin`.
 */
export const SITE_INDEXABLE: boolean = /(^|\.)glastotaal\.nl$/i.test(new URL(SITE_URL).hostname);
